import { throttle } from "lodash-es";
import { useCallback, useEffect } from "react";

export const useScrollPositionRestore = () => {
    const buildCacheKey = (pathname: string) =>
        `__uxuy_dex_cached_scroll_position_${pathname}__`;

    const savePosition = useCallback((e?: Event) => {
        const pathname = window.location.pathname;
        const container =
            (e?.currentTarget as HTMLDivElement) ??
            (document.getElementById("tg-main-content") as HTMLDivElement);
        if (container) {
            const scrollTop = Number(container.scrollTop ?? 0);
            sessionStorage.setItem(buildCacheKey(pathname), String(scrollTop));
        }
    }, []);

    useEffect(() => {
        const container = document.getElementById(
            "tg-main-content"
        ) as HTMLDivElement;

        const onScroll = throttle(savePosition, 150);

        container?.addEventListener("scroll", onScroll);

        return () => {
            container?.removeEventListener("scroll", onScroll);
        };
    });

    const restorePosition = useCallback(() => {
        setTimeout(() => {
            const pathname = window.location.pathname;
            const container = document.getElementById(
                "tg-main-content"
            ) as HTMLDivElement;
            const cacheKey = buildCacheKey(pathname);
            if (container) {
                const savedPosition = sessionStorage.getItem(cacheKey);
                const positionNum = Number(savedPosition);
                if (
                    savedPosition &&
                    !Number.isNaN(positionNum) &&
                    Number.isSafeInteger(positionNum)
                ) {
                    container.scrollTo(0, positionNum);
                }
            }
        }, 40);
    }, []);

    return { savePosition, restorePosition };
};
